import { createModalHook } from '../../hooks/useModal'

export const useEditEmailAddressModal = createModalHook()
